export const ELEMENTS_PAGE_SIZE = 30;
